// extracted by mini-css-extract-plugin
export default {"list":"PersonalTrainingsDescrForm_list__+wxe7","button":"PersonalTrainingsDescrForm_button__CtaaJ"};